import { createEvent, createStore } from 'effector';

const $search = createStore<string>('');
const setSearch = createEvent<string | undefined>();

$search.on(setSearch, (state, payload) => payload || '');

const $isSearchEmpty = $search.map((value) => value.trim() === '');

export const SEARCH = {
  $search,
  $isSearchEmpty,
  setSearch,
};
